import { clearFilters } from '@fides/fides-react-components';

export class ColumnUtil {

    static resetColumns(tableParams, tableController) {

        delete tableParams.columns;
        delete tableParams.filterModel;
        // update the tableParams with columns definition updated db
        tableController.sessionPersistance.set( tableController.sessionPersistance.dataKey, tableParams);

        // reset filtermodel
        clearFilters(tableController.gridApi);
        // reset selection
        tableController.resetGridSelection();
        // reset sort order to default
        tableController.gridColumnApi.resetColumnState();
        tableController.gridApi.sizeColumnsToFit();
        tableController.gridColumnApi.applyColumnState({ state: tableController.defaultSortModel });
    }

    static saveFilter(tableParams, tableController) {
        tableParams.filterModel = tableController.gridApi.getFilterModel();
        const sessionPersistance = tableController.sessionPersistance;
        sessionPersistance.set(sessionPersistance.dataKey, tableParams);
    }
}
